import { useContext } from 'react'

import { ComposerContext } from '../ComposerContext.js'

export const useComposer = () => useContext(ComposerContext)
